export const FontBase = () => (
  <style>
    {`

@font-face {
font-family: 'SEBSansSerif';
src: url('https://jirangopub.s3.eu-north-1.amazonaws.com/Files/9962/SEBSansSerif-Regular.woff2');
}


* {
font-family: 'SEBSansSerif'
font-weight: 400;
}


`}
  </style>
);
